import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'

export default {
  name: 'templateFilter',
  components: {},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      form: {
        Apr: null,
        InicioDataSolicitacao: null,
        FimDataSolicitacao: null
      }
    }
  },
  mounted () {
  },
  methods: {
    Search () {
      this.$emit('search', {APR: this.form.Apr, dataInicio: this.form.InicioDataSolicitacao, dataFim: this.form.FimDataSolicitacao})
    },
    onClearSection () {
      this.form.Apr = null
      this.form.InicioDataSolicitacao = null
      this.form.FimDataSolicitacao = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/templateFilter/templateFilter.js